<template>
<div class="legend" :style="{ borderBottomColor: getTheme.fore }">
  <strong>
    {{ title }}
  </strong>
  <label v-if="link"><a :style="{ color: getTheme.fore }" :href="link" target="blank">(?)</a></label>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DetailListHeader',
  props: ['title', 'link'],
  computed: {
    ...mapGetters(['getTheme'])
  }
}
</script>

<style lang="scss" scoped>
label {
  a {
    text-decoration: none;
  }
}
.legend {
  margin: 12px 0 8px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  font-size: 1.2rem;
}
</style>
